import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { gsap } from 'gsap';
import env from '../../assets/scripts/utils/env';
import Scroll from '../../assets/scripts/helpers/Scroll';

const HTML_CLASSLIST = document.documentElement.classList;

const ClassName = {
	MENU_OPENED: '_menu-opened',
	MENU_OPENING: '_menu-opening',
	MENU_CLOSING: '_menu-closing',
	MOBILE_HIDE: '_mobile-hide',
};

class Header {
	constructor() {
		this.init();
	}

	init() {
		this.container = document.querySelector('[data-menu]');
		this.header = document.querySelector('[data-header]');
		this.closed = document.querySelector('[data-close-menu]');
		this.menuItems = document.querySelectorAll('.menu__item');

		if (!this.container || !this.header) {
			return;
		}

		this.burgerMenuItems = this.container.querySelectorAll('.menu > *');

		this._onOpenerClick = this._onOpenerClick.bind(this);
		this._onWindowKeydown = this._onWindowKeydown.bind(this);
		this._onWindowResize = this._onWindowResize.bind(this);

		const openers = document.querySelectorAll('[data-menu-opener]');

		this.closed.addEventListener('click', () => {
			this.close();
		});

		openers.forEach((opener) => {
			opener.addEventListener('click', this._onOpenerClick);
		});

		window.addEventListener('keydown', this._onWindowKeydown);
		window.addEventListener('resize', this._onWindowResize);

		this.submenu();
	}
	submenu() {
		this.menuItems.forEach((menuItem) => {
			menuItem.addEventListener('click', (e) => {
				const target = e.currentTarget;

				this.header.classList.toggle('_active');
				target.classList.toggle('_active');
			});
		});
	}
	open() {
		HTML_CLASSLIST.add(ClassName.MENU_OPENING);

		clearTimeout(this.animTO);
		this.animTO = setTimeout(() => {
			HTML_CLASSLIST.remove(ClassName.MENU_OPENING);
			HTML_CLASSLIST.add(ClassName.MENU_OPENED);

			if (this.header.classList.contains(ClassName.MOBILE_HIDE)) {
				this.mobileHide = true;
				this.header.classList.remove(ClassName.MOBILE_HIDE);
			}
		}, 300);

		gsap.from(this.burgerMenuItems, {
			y: -20,
			opacity: 0,
			stagger: 0.05,
			duration: 0.5,
			ease: 'power2.inOut',
			delay: 0.15,
		});

		Scroll.disabled(this.container);
	}
	close() {
		if (!HTML_CLASSLIST.contains(ClassName.MENU_OPENED)) {
			return;
		}
		HTML_CLASSLIST.add(ClassName.MENU_CLOSING);

		clearTimeout(this.animTO);
		this.animTO = setTimeout(() => {
			HTML_CLASSLIST.remove(ClassName.MENU_CLOSING);
			HTML_CLASSLIST.remove(ClassName.MENU_OPENED);

			if (this.mobileHide) {
				this.mobileHide = false;
				this.header.classList.add(ClassName.MOBILE_HIDE);
			}
		}, 300);

		Scroll.enabled(this.container);
	}
	toggle() {
		HTML_CLASSLIST.contains(ClassName.MENU_OPENED) ? this.close() : this.open();
	}
	_onOpenerClick(evt) {
		evt.preventDefault();

		this.open();
	}
	_onWindowKeydown(evt) {
		if (evt.key === 'Escape') {
			this.close();
		}
	}
	_onWindowResize() {
		if (window.innerWidth > 768) {
			this.close();
		}
	}
}

export default new Header();
